import React from 'react'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../routers/routes'

import './Error404.scss'

const Error404 = () => {
  const history = useHistory()
  const handleNavigate = () => {
    history.push(ROUTES.HOME.pathname)
  }
  return (
    <section className="error__page">
      <div className="error__container">
        <h4>Error 404</h4>
        <div className="error__container__info">
          <h3>Lo sentimos, la página no funciona</h3>
          <p>La página que está solicitando no ha sido encontrada</p>
          <button
            className="button button__primary"
            onClick={() => handleNavigate()}
          >
            Home
          </button>
        </div>
      </div>
    </section>
  )
}

export default Error404
